import * as React from 'react';
import { Option, PhaseNameCase } from '@/interfaces';
import Icons from '@/const/icons';
import { useLayout } from '@/context/LayoutContext';
import AppRoutes from '@/const/routes';
import { useRouter } from 'next/router';
import clsx from 'clsx';

const isAdministrationPage: PhaseNameCase[] = [
	'Investigation',
	'Applicant Intake',
	'Active Case',
	'Settlement',
].map((name) => name.replaceAll(' ', '-').toLowerCase()) as PhaseNameCase[];

export const CaseView = () => {
	const router = useRouter();
	const { id, tab } = router.query;
	const pathname = router.pathname.split('/').at(-1) ?? '';
	const { setSubSidebar } = useLayout();

	const isCaseCreated = !!id;
	const baseRoute = `${AppRoutes.LAWYERAPP_CASES}/${id}`;

	const sections: Option[] = [
		{
			label: 'Administration',
			name: 'Administration',
			icon: Icons.setting5,
			href: isCaseCreated ? `${baseRoute}/investigation` : '',
			className: clsx({
				'bg-bg-primary':
					isAdministrationPage.includes(pathname as any) || !isCaseCreated,
			}),
		},
		// {
		// 	label: 'Actions',
		// 	name: 'Actions',
		// 	icon: Icons.book,
		// 	href: `${baseRoute}/actions-required`,
		// 	className: clsx({ 'opacity-30': !isCaseCreated }),
		// 	disabled: !isCaseCreated,
		// },
		{
			label: 'Clients',
			name: 'Clients',
			icon: Icons.profileUsers,
			href: `${baseRoute}/clients`,
			className: clsx({
				'bg-bg-primary': tab === 'case-clients',
				'opacity-30': !isCaseCreated,
			}),
			disabled: !isCaseCreated,
		},
		{
			label: 'Metrics',
			name: 'Metrics',
			icon: Icons.graph,
			href: `${baseRoute}/metrics`,
			className: clsx({ 'opacity-30': !isCaseCreated }),
			disabled: !isCaseCreated,
		},
		{
			label: 'Documentation',
			name: 'Documentation',
			icon: Icons.documentFile,
			href: `${baseRoute}/documentation`,
			className: clsx({ 'opacity-30': !isCaseCreated }),
			disabled: !isCaseCreated,
		},
	];

	React.useEffect(() => {
		setSubSidebar({
			title: 'Case Management',
			sections,
		});

		return () => setSubSidebar(null);
	}, [id, pathname]);

	return null;
};
